import React from 'react'
import { Input, Button } from '../../../components'
import { Link, useHistory } from 'react-router-dom'
import auth from '../../../utils/auth'

const Form = ({className}) => {
  const [form, setForm] = React.useState({})
  const history = useHistory()
  const { check, login } = auth()

  const updateForm = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleLogin = () => {
    check(form).then(res => {
      if(res.status === 200){
        login(res)
        history.push('/')
      }
    }).catch(err => {
      if(err.message){
        alert(err.message)
      }
    })
  }

  return (
    <form className={`${className}`}>
      <Input
        placeholder="Email"
        className="w-full mb-3"
        type="email"
        name="email"
        onChange={updateForm}
      />
      <Input
        placeholder="Password"
        className="w-full mb-5 lg:mb-8"
        type="password"
        name="password"
        onChange={updateForm}
      />
      <div className="mb-5 lg:mb-8 text-sm flex justify-between text-gray-444">
        <div className="flex items-center">
          <input type="checkbox" id="remember" className="mr-2 block"/>
          <label htmlFor="remember" className="cursor-pointer">Remember me</label>
        </div>
        <div>
          <Link to="/forgot-password" className="underline">Forgot Password?</Link>
        </div>
      </div>
      <Button className="hidden lg:block" onClick={handleLogin}>Login</Button>
      <Button className="lg:hidden" thin onClick={handleLogin}>Login</Button>
    </form>
  )
}

export { Form }
